/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable react/prop-types */
// ProductsList page components
import IdCell from "layouts/ecommerce/orders/order-list/components/IdCell";
import DefaultCell from "layouts/ecommerce/orders/order-list/components/DefaultCell";
import StatusCell from "layouts/ecommerce/orders/order-list/components/StatusCell";
import CustomerCell from "layouts/ecommerce/orders/order-list/components/CustomerCell";

// Images
import team2 from "assets/images/team-2.jpg";
import PeriodCell from "layouts/management/popup/popup-list/components/PeriodCell";
import MDButton from "components/MDButton";

const dataTableData = (list?: any, func?: any) => {
  return {
    columns: [
      { Header: "번호", accessor: "pIdx", Cell: ({ value }: any) => <IdCell id={value} /> },
      { Header: "설명", accessor: "description", Cell: ({ value }: any) => <IdCell id={value} /> },
      {
        Header: "기간",
        accessor: "period",
        Cell: ({ value }: any) => <PeriodCell startDt={value[0]} endDt={value[1]} />,
      },
      { Header: "표시", accessor: "isDisplay", Cell: ({ value }: any) => <IdCell id={value} /> },
      {
        Header: "수정",
        accessor: "pIdx2",
        Cell: ({ value }: any) => (
          <MDButton onClick={func ? () => func(value) : () => {}}>수정</MDButton>
        ),
      },
    ],

    rows: !list
      ? [
          {
            id: "",
            description: "",
            period: ["", ""],
            isDisplay: "",
          },
        ]
      : list,
  };
};

export default dataTableData;
